import { render, staticRenderFns } from "./uploadModels.vue?vue&type=template&id=83b83252"
import script from "./uploadModels.vue?vue&type=script&lang=js"
export * from "./uploadModels.vue?vue&type=script&lang=js"
import style0 from "./uploadModels.vue?vue&type=style&index=0&id=83b83252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports